import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';
import { AlertService } from '../../../_shared/services/alert.service';
import { UtilService } from '../../../_shared/services/util.service';

import { PickupPlace } from '../../shared/pickup-place.model';
import { PickupPlaceService } from '../../shared/pickup-place.service';

@Component({
  selector: 'app-pickup-place-translation-modal',
  templateUrl: './pickup-place-translation-modal.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class PickupPlaceTranslationModalComponent {
  pickupPlace: PickupPlace = null;
  pickupPlaceCopy = null;

  modalTitle = this.data.title;
  pickupPlaceId = this.data.obj.id;
  language = this.data.params.language;

  form: FormGroup;

  serverErrors = [];
  sendingForm = false;

  constructor(
    private alertService: AlertService,
    private utilService: UtilService,
    private pickupPlaceService: PickupPlaceService,
    private formBuilder: FormBuilder,
    private ref: MatDialogRef<PickupPlaceTranslationModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {
    // use it onInit ??
    this.getPickupPlace();
  }

  // Referenced from app-item-detail-form-actions
  onSavedPickupPlaceTranslation() {
    if (this.form.invalid) {
      this.serverErrors = [];

      return;
    }

    const formData = this.form.value;

    // console.log(formData);
    // console.log(this.pickupPlaceCopy);
    // return;

    const fields = ['name', 'address'];

    if (!fields.some((field) => formData[field] !== this.pickupPlaceCopy[field])) {
      this.close();
      return;
    }

    this.sendingForm = true;

    this.pickupPlaceService
      .savePickupPlace(this.pickupPlace.id, formData, this.language.lang)
      .subscribe({
        next: (response) => {
          this.alertService.open('TRANSLATION_SAVED');

          this.sendingForm = false;

          this.ref.close(response);
        },
        error: (response) => {
          this.serverErrors = this.utilService.setFormServerErrors(response.error.errors);

          this.sendingForm = false;
        },
      });
  }

  onCanceled() {
    this.close();
  }

  close() {
    this.ref.close();
  }

  private getPickupPlace() {
    let params = {
      get: 'translate',
      lang: this.language.lang,
    };

    this.pickupPlaceService.getPickupPlace(this.pickupPlaceId, params).subscribe((pickupPlace) => {
      this.pickupPlace = pickupPlace;
      this.pickupPlaceCopy = { ...this.pickupPlace };

      this.setPickupPlaceTranslationForm();

      this.form.patchValue(this.pickupPlace);
    });
  }

  private setPickupPlaceTranslationForm() {
    this.form = this.formBuilder.group({
      name: [
        '',
        {
          validators: [
            Validators.required,
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      address: '',
    });
  }
}

/*

// const formData = this.utilService.deleteNullFields(fields, this.form.value);

this.form = this.formBuilder.group({
      name: [
        this.pickupPlace.name,
        {
          validators: [
            Validators.required,
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      address: [this.pickupPlace.address],
    });
*/
